// extracted by mini-css-extract-plugin
export var modal = "_u3-0";
export var table = "_u3-1";